import { createContext, useContext, useState, useCallback } from "react";

interface ConceptSearchContextValue {
  open: boolean;
  setOpen: (open: boolean) => void;
  toggle: () => void;
}

const ConceptSearchContext = createContext<ConceptSearchContextValue | null>(null);

export function ConceptSearchProvider({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);
  const toggle = useCallback(() => setOpen((o) => !o), []);
  return (
    <ConceptSearchContext.Provider value={{ open, setOpen, toggle }}>
      {children}
    </ConceptSearchContext.Provider>
  );
}

export function useConceptSearch() {
  const ctx = useContext(ConceptSearchContext);
  if (!ctx) throw new Error("useConceptSearch must be used within ConceptSearchProvider");
  return ctx;
}
